<div class="grid-container">
  <div class="item5 p-0">
    <nav class="navbar navbar-expand-lg">
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="nav nav-tabs line-tab">
          <li class="nav-item" role="presentation">
            <a
              class="nav-link show active"
              id="boardTab"
              #boardTab
              data-toggle="tab"
              (click)="onTabChange('board')"
              href="#board-info"
              role="tab"
              aria-selected="true">
              Board
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a
              class="nav-link"
              data-toggle="tab"
              #filterTab
              (click)="onTabChange('filter')"
              href="#certifications"
              role="tab"
              aria-selected="false">
              Filter
            </a>
          </li>
          <li
            [ngClass]="{ 'hide-format': !isAllowed('job_board_attributes', 'edit') }"
            class="nav-item"
            role="presentation">
            <a
              class="nav-link"
              data-toggle="tab"
              #formatTab
              (click)="onTabChange('format')"
              href="#format"
              role="tab"
              aria-selected="false">
              Format
            </a>
          </li>
        </ul>
        <div class="d-flex align-items-center">
          <div class="d-flex mx-4">
            <span class="font-weight-bold h5 mx-2">Job Count:</span>
            <span class="h5 font-weight-bold">{{ jobCount || '-' }}</span>
          </div>
          <div class="d-flex mx-5">
            <span class="font-weight-bold h5 mx-2">Active Employees:</span>
            <span class="h5 font-weight-bold">{{ activeEmployeeCount || '-' }}</span>
          </div>
          <div *ngIf="isAllowed('job_board_attributes', 'edit')" class="d-flex mx-5">
            <span (click)="toggleJobBoardLock()" role="button" *ngIf="!loading; else loadingIcon" class="font-weight-bold h5 mx-2"
              ><i style="font-size: xx-large" [class]="!jobBoardLocked ? 'fa fa-lock-open' : 'fa fa-lock'"
              [title]="jobBoardLocked ? 'Unlock Job Board' : 'Lock Job Board'"></i
            ></span>
            <ng-template #loadingIcon>
              <span style="display: block">
                <i
                  *ngIf="loading"
                  style="font-size: xx-large; animation: fa-spin 2s linear infinite"
                  [ngClass]="{ 'fa fa-refresh': true, 'fa-spin': loading }"></i>
              </span>
            </ng-template>
          </div>
          <div *ngIf="isAllowed('job_board_attributes', 'edit')" class="dropdown">
            <button
              class="btn btn-success dropdown-toggle action-button"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              data-bs-auto-close="outside">
              Board Actions
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a (click)="toggleJobBoardLock()" class="dropdown-item" href="javascript:void(0);"
                ><i [class]="jobBoardLocked ? 'fa fa-lock-open' : 'fa fa-lock'"></i>
                {{ jobBoardLocked ? 'Unlock' : 'Lock' }} Board</a
              >
              <a (click)="generateExport()" class="dropdown-item" href="javascript:void(0);"
                ><i class="fa fa-file-export"></i> Export</a
              >
              <a (click)="printPreview()" class="dropdown-item" href="javascript:void(0);"
                ><i class="fa fa-print"></i> Print</a
              >
              <li (click)="$event.stopPropagation()">
                <hr class="dropdown-divider" />
                <p class="dropdown-header bold">Job Card Grouping</p>
                <app-job-board-group-by class="dropdown-item" (group)="groupBoardData($event)"></app-job-board-group-by>
              </li>
            </div>
          </div>
          <a
            class="btn btn-success dropdown-toggle legend-button ml-2"
            role="button"
            href="#collapseExample"
            data-toggle="collapse"
            aria-controls="collapseExample"
            aria-haspopup="true"
            aria-expanded="false"
            data-bs-auto-close="outside">
            Legend
          </a>
          <div class="collapse legend-card" id="collapseExample">
            <div class="card card-body">
              <app-job-legend-nav></app-job-legend-nav>
            </div>
          </div>
          <div *ngIf="selectedEmployees?.length" class="batch-actions ml-2">
            <div *ngIf="isAllowed('job_board_attributes', 'edit')" class="dropdown">
              <button
                class="btn btn-secondary dropdown-toggle batch-employee-action-button"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-bs-auto-close="outside">
                <i
                  class="fa fa-times-circle mt-1 mr-1"
                  title="Clear Selected Employees"
                  (click)="clearSelectedEmployees(); $event.stopPropagation()"></i>
                Employee Actions ({{ selectedEmployees?.length }})
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <button
                  [disabled]="jobBoardLocked"
                  class="dropdown-item"
                  (click)="reassignBatchEmployees(); $event.stopPropagation()">
                  <i class="fa fa-arrow-alt-right"></i> Move to Job...
                </button>
                <button
                  [disabled]="jobBoardLocked"
                  class="dropdown-item"
                  (click)="assignBatchEmployees(); $event.stopPropagation()">
                  <i class="fa fa-copy"></i> Copy to Job...
                </button>
                <button
                  [disabled]="jobBoardLocked"
                  class="dropdown-item"
                  (click)="removeBatchEmployees(); $event.stopPropagation()"
                  style="color: red">
                  <i class="fa fa-trash"></i> Remove
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</div>

<app-add-employee-job></app-add-employee-job>
<app-job-pointe-transfer [refreshEmployeesSource]="getDepartmentJobCardData.bind(this)"></app-job-pointe-transfer>

<div *ngIf="jobBoardCardData" class="h-100 modal-container">
  <div class="row">
    <div class="col-12 p-0">
      <div #container class="tab-content body-content-scroll scrollbar">
        <!-- Board Tab -->
        <div class="tab-pane show active" id="board-info" role="tabpanel">
          <div class="card mt-1 border-0 table-height">
            <div class="card-body mb-5 p-0">
              <app-job-card-list
                [ngStyle]="{ visibility: boardTab.classList.contains('active') ? 'visible' : 'hidden' }"
                [jobBoardCardData]="jobBoardCardData"
                [id]="'board'">
              </app-job-card-list>
            </div>
          </div>
        </div>
        <!-- Board Tab End-->
        <!-- Filter -->
        <div class="tab-pane fade" id="certifications" role="tabpanel">
          <app-job-pointe-settings-bar
            class="filter-nav"
            (filter)="filterBoardData($event)"
            (clear)="clearFilters($event)"
            [filters]="filters"
            [jobPointeSettingsData]="settingsData"
            [source]="settingsData.type"
            (search)="filterBoardData({ search: $event })">
          </app-job-pointe-settings-bar>
          <div class="card mt-1 border-0 table-height">
            <div class="card-body filter-card mb-5 p-0">
              <app-job-card-list
                [ngStyle]="{ visibility: filterTab.classList.contains('active') ? 'visible' : 'hidden' }"
                [jobBoardCardData]="jobBoardCardData"
                [id]="'filter'">
              </app-job-card-list>
            </div>
          </div>
        </div>
        <!-- Filter End -->
        <!-- Format -->
        <div *ngIf="isAllowed('job_board_attributes', 'edit')" class="tab-pane fade" id="format" role="tabpanel">
          <app-job-format-nav
            class="format-nav"
            [ngStyle]="{
              visibility: formatTab.classList.contains('active') ? 'visible' : 'hidden'
            }"></app-job-format-nav>
          <div
            [ngStyle]="{ visibility: formatTab.classList.contains('active') ? 'visible' : 'hidden' }"
            class="card format-card format-container-border table-height pl-3">
            <div class="format-btn">
              Formatting Mode <a (click)="boardTab.click()"><img src="/assets/images/icon/close_white.svg" /></a>
            </div>
            <div class="card-body mb-5 p-0">
              <app-job-card-list [jobBoardCardData]="jobBoardCardData" [id]="'format'"> </app-job-card-list>
            </div>
          </div>
        </div>
        <!-- Format End -->
      </div>
      <!-- </form> -->
    </div>
  </div>
</div>

<app-dialog id="board-lock-dialog">
  <div class="dialog-header d-flex justify-content-between">
    <h5 class="modal-title" id="exampleModalLabel">{{ dialogAction }} Job Board</h5>
  </div>
  <span class="dialog-body">
    <p>Are you sure you want to {{ dialogAction.toLowerCase() }} the job board?</p>
  </span>
  <span class="dialog-footer">
    <button type="button" class="btn btn-primary" data-dismiss="modal">Cancel</button>
    <button type="button" class="btn btn-primary ml-3" id="board-lock-dialog_btn-ok">Continue</button>
  </span>
</app-dialog>

<app-dialog id="facility-selection-dialog">
  <div class="dialog-header d-flex justify-content-between align-items-center">
    <h5 class="modal-title">
      {{ dialogAction }}
      <span style="color: #057aff">
        {{
          selectedEmployees.length > 1
            ? selectedEmployees.length + ' Employees'
            : selectedEmployees[0]?.employeeAlias
              ? selectedEmployees[0].employeeAlias
              : selectedEmployees[0]?.firstName +
                '
        ' +
                selectedEmployees[0]?.lastName
        }}</span
      >
      to
      <span style="color: #d91e41">
        {{
          selectedFacilityJob?.isSeparateOnJobBoard
            ? selectedFacilityJob?.jobNumber + ' - ' + selectedFacilityJob?.name || '...'
            : selectedFacilityJob?.facility?.facilityName || '...'
        }}
      </span>
    </h5>
  </div>
  <span class="dialog-body">
    <input
      #facilitySearch
      class="form-control"
      placeholder="Search Facility Jobs"
      type="search"
      (input)="filterFacilityJobs(facilitySearch.value)" />
    <table class="select-facility-table">
      <tr *ngFor="let job of jobsList">
        <td
          (click)="selectFacilityJob(job)"
          [ngClass]="{
            selected: selectedFacilityJob?.id == job.id && selectedFacilityJob.facility.id == job.facility.id
          }">
          {{ job.jobNumber }} - {{ job.name }}
        </td>
      </tr>
    </table>
  </span>
  <span class="dialog-footer">
    <button
      (click)="facilitySearch.value = null; filterFacilityJobs(facilitySearch.value)"
      type="button"
      class="btn btn-outline-primary"
      data-dismiss="modal">
      Cancel
    </button>
    <button
      (click)="facilitySearch.value = null; filterFacilityJobs(facilitySearch.value)"
      [disabled]="!selectedFacilityJob?.id"
      type="button"
      class="btn btn-primary ml-3"
      id="facility-selection-dialog_btn-ok">
      {{ dialogAction }}
    </button>
  </span>
</app-dialog>
